import React, { lazy } from 'react';
import {
  ConcurrentLoanJourneyRoutes,
  L0JourneyRoutes,
  LNJourneyRoutes,
  LNJourneyShortenedRoutes,
  PostProcessingRoutes
} from '../../../utils/RouterRoutes';

import { defaultAppSettings } from '../../../contexts/AppSettingsContext';

const DocumentUploadOld = lazy(() => import('../../../components/DocumentUpload/DocumentUploadOld'));
const DocumentUploadNew = lazy(() => import('../../../components/DocumentUpload/DocumentUploadNew'));

const AffordabilityDetailsPage = lazy(() => import('../JourneyPages/AffordibilityDetails'));
const BankDetailsPage = lazy(() => import('../JourneyPages/BankDetails'));
const OtpPage = lazy(() => import('../JourneyPages/NewOtp'));
const EmploymentDetailsPage = lazy(() => import('../JourneyPages/EmploymentDetails'));
const AffordabilityChallengePage = lazy(() => import('../JourneyPages/AffordabilityChallenge'));
const CustomerDetailsPage = lazy(() => import('../JourneyPages/CustomerDetails'));
const ConfirmDetailsSummaryV2 = lazy(() => import('../JourneyPages/LN/ConfirmDetailsSummary/ConfirmDetailsSummaryV2'));
const Processing = lazy(() => import('../JourneyPages/Processing'));
const TermsAndConditionsPage = lazy(() => import('../JourneyPages/Decisions/Approved/TermsAndConditions'));
const Declined = lazy(() => import('../JourneyPages/Decisions/Declined/Declined'));
const CounterofferProcessing = lazy(() => import('../JourneyPages/Decisions/counteroffer/CounterofferProcessing'));
const CounterOffer = lazy(() => import('../../MyLoan/AccountSummary/CounterOffer/CounterOffer'));
const CounterOfferDeclined = lazy(() => import('../JourneyPages/Decisions/Declined/CounterOfferDeclined'));
const CreditLifePlus = lazy(() => import('../JourneyPages/VAS/CreditLifePlus/CreditLifePlus'));
const CreditLifePlusBeneficiary = lazy(() => import('../JourneyPages/VAS/CreditLifePlus/CreditLifePlusBeneficiary'));
const CreditLifeLoanRepaymentDetails = lazy(() => import('../JourneyPages/VAS/CreditLifePlus/CreditLifeLoanRepaymentDetails'));

const UpdateIncomeExpenses = lazy(() => import('../JourneyPages/LN/UpdateIncomeExpenses/UpdateIncomeExpenses'));
const ConcurrentLoanOffer = lazy(() => import('../JourneyPages/ConcurrentLoan/ConcurrentLoanOffer'));
const IvOptions = lazy(() => import('../JourneyPages/IncomeVerification/IvOptions'));
const OpenBankingProcessing = lazy(() => import('../JourneyPages/IncomeVerification/OpenBankingProcessing'));
const FailedOpenBanking = lazy(() => import('../JourneyPages/IncomeVerification/FailedOpenBanking'));
const CancelledOpenBanking = lazy(() => import('../JourneyPages/IncomeVerification/CancelledOpenBanking'));

import AffordabilityChallengeProcessing from '../JourneyPages/AffordabilityChallenge/AffordabilityChallengeProcessing';
export interface JourneyConfig<RouteTypeEnum> {
  path: RouteTypeEnum;
  element: React.ReactElement;
}

export const l0journey: JourneyConfig<L0JourneyRoutes>[] = [
  { path: L0JourneyRoutes.otp, element: <OtpPage /> },
  { path: L0JourneyRoutes.details, element: <CustomerDetailsPage /> },
  { path: L0JourneyRoutes.employment, element: <EmploymentDetailsPage /> },
  { path: L0JourneyRoutes.affordability, element: <AffordabilityDetailsPage /> },
  { path: L0JourneyRoutes.bank, element: <BankDetailsPage /> },
  { path: L0JourneyRoutes.creditLifePlus, element: <CreditLifePlus /> },
  { path: L0JourneyRoutes.creditLifeLoanRepaymentDetails, element: <CreditLifeLoanRepaymentDetails /> },
  { path: L0JourneyRoutes.creditLifePlusBeneficiary, element: <CreditLifePlusBeneficiary /> },
  { path: L0JourneyRoutes.processing, element: <Processing /> },
]
  .filter((routes) =>
    !defaultAppSettings.insurance.deathBenefitIncludeBeneficiaryDetails
      ? routes.path !== L0JourneyRoutes.creditLifePlusBeneficiary
      : true
  )
  .filter((x) =>
    !defaultAppSettings.insurance.deathBenefitEnabled
      ? x.path !== L0JourneyRoutes.creditLifePlus &&
      x.path !== L0JourneyRoutes.creditLifePlusBeneficiary &&
      x.path !== L0JourneyRoutes.creditLifeLoanRepaymentDetails
      : true
  );

export const lnJourney: JourneyConfig<LNJourneyRoutes>[] = [
  { path: LNJourneyRoutes.otp, element: <OtpPage /> },
  { path: LNJourneyRoutes.details, element: <CustomerDetailsPage /> },
  { path: LNJourneyRoutes.employment, element: <EmploymentDetailsPage /> },
  { path: LNJourneyRoutes.affordability, element: <AffordabilityDetailsPage /> },
  { path: LNJourneyRoutes.bank, element: <BankDetailsPage /> },
  { path: LNJourneyRoutes.creditLifePlus, element: <CreditLifePlus /> },
  { path: LNJourneyRoutes.creditLifeLoanRepaymentDetails, element: <CreditLifeLoanRepaymentDetails /> },
  { path: LNJourneyRoutes.creditLifePlusBeneficiary, element: <CreditLifePlusBeneficiary /> },
  { path: LNJourneyRoutes.processing, element: <Processing /> },
]
  .filter((routes) =>
    !defaultAppSettings.insurance.deathBenefitIncludeBeneficiaryDetails
      ? routes.path !== LNJourneyRoutes.creditLifePlusBeneficiary
      : true
  )
  .filter((x) =>
    !defaultAppSettings.insurance.deathBenefitEnabled
      ? x.path !== LNJourneyRoutes.creditLifePlus &&
      x.path !== LNJourneyRoutes.creditLifePlusBeneficiary &&
      x.path !== LNJourneyRoutes.creditLifeLoanRepaymentDetails
      : true
  );

export const lnJourneyShortened: JourneyConfig<LNJourneyShortenedRoutes>[] = [
  { path: LNJourneyShortenedRoutes.confirmDetails, element: <ConfirmDetailsSummaryV2 /> },
  { path: LNJourneyShortenedRoutes.updateIncomeExpenses, element: <UpdateIncomeExpenses /> },
  { path: LNJourneyShortenedRoutes.creditLifePlus, element: <CreditLifePlus /> },
  { path: LNJourneyShortenedRoutes.creditLifeLoanRepaymentDetails, element: <CreditLifeLoanRepaymentDetails /> },
  { path: LNJourneyShortenedRoutes.creditLifePlusBeneficiary, element: <CreditLifePlusBeneficiary /> },
  { path: LNJourneyShortenedRoutes.processing, element: <Processing /> },
]
  .filter((routes) =>
    !defaultAppSettings.insurance.deathBenefitIncludeBeneficiaryDetails
      ? routes.path !== LNJourneyShortenedRoutes.creditLifePlusBeneficiary
      : true
  )
  .filter((x) =>
    !defaultAppSettings.insurance.deathBenefitEnabled
      ? x.path !== LNJourneyShortenedRoutes.creditLifePlus &&
      x.path !== LNJourneyShortenedRoutes.creditLifePlusBeneficiary &&
      x.path !== LNJourneyShortenedRoutes.creditLifeLoanRepaymentDetails
      : true
  );

export const concurrentLoanJourney: JourneyConfig<ConcurrentLoanJourneyRoutes>[] = [
  { path: ConcurrentLoanJourneyRoutes.concurrentLoanOffer, element: <ConcurrentLoanOffer /> },
  { path: ConcurrentLoanJourneyRoutes.confirmDetails, element: <ConfirmDetailsSummaryV2 /> },
  { path: ConcurrentLoanJourneyRoutes.updateIncomeExpenses, element: <UpdateIncomeExpenses /> },
  { path: ConcurrentLoanJourneyRoutes.creditLifePlus, element: <CreditLifePlus /> },
  { path: ConcurrentLoanJourneyRoutes.creditLifeLoanRepaymentDetails, element: <CreditLifeLoanRepaymentDetails /> },
  { path: ConcurrentLoanJourneyRoutes.creditLifePlusBeneficiary, element: <CreditLifePlusBeneficiary /> },
  { path: ConcurrentLoanJourneyRoutes.processing, element: <Processing /> },
]
  .filter((routes) =>
    !defaultAppSettings.insurance.deathBenefitIncludeBeneficiaryDetails
      ? routes.path !== ConcurrentLoanJourneyRoutes.creditLifePlusBeneficiary
      : true
  )
  .filter((x) =>
    !defaultAppSettings.insurance.deathBenefitEnabled
      ? x.path !== ConcurrentLoanJourneyRoutes.creditLifePlus &&
      x.path !== ConcurrentLoanJourneyRoutes.creditLifePlusBeneficiary &&
      x.path !== ConcurrentLoanJourneyRoutes.creditLifeLoanRepaymentDetails
      : true
  );

export const PostProcessing: JourneyConfig<PostProcessingRoutes>[] = [
  { path: PostProcessingRoutes.agreement, element: <TermsAndConditionsPage /> },
  { path: PostProcessingRoutes.documentUpload, element: defaultAppSettings.pageToggles.newDocumentUploadPage ? < DocumentUploadNew /> : <DocumentUploadOld /> },
  { path: PostProcessingRoutes.declined, element: <Declined /> },
  { path: PostProcessingRoutes.counterOffer, element: <CounterOffer /> },
  { path: PostProcessingRoutes.counterOfferDecline, element: <CounterOfferDeclined /> },
  { path: PostProcessingRoutes.counterOfferProcessing, element: <CounterofferProcessing /> },
  { path: PostProcessingRoutes.IvOptions, element: <IvOptions /> },
  { path: PostProcessingRoutes.OpenBankingProcessing, element: <OpenBankingProcessing /> },
  { path: PostProcessingRoutes.OpenBankingFailure, element: <FailedOpenBanking /> },
  { path: PostProcessingRoutes.OpenBankingCancelled, element: <CancelledOpenBanking /> },
  { path: PostProcessingRoutes.affordabilityChallenge, element: <AffordabilityChallengePage /> },
  { path: PostProcessingRoutes.affordabilityChallengeProcessing, element: <AffordabilityChallengeProcessing /> }
];
